import { Component, computed, inject, model } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ProfileFacade } from '@app/store/profile';
import { ThemeService } from '@app/core/theme/theme.service';
import { AvatarComponent, LogoComponent } from '@shared/components';
import { ClIcon } from '@corelabs/angular/ui';
import { LogOut, Menu, Moon, Sun, X } from 'lucide';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    host: { class: 'theme-dark' },
    imports: [RouterLink, TranslatePipe, AvatarComponent, ClIcon, LogoComponent],
})
export class HeaderComponent {
    protected readonly icons = { LogOut, Menu, Moon, Sun, X };

    /** The sidebar drawer below lg. */
    readonly menuOpen = model(false);

    private readonly profileFacade = inject(ProfileFacade);
    readonly themeService = inject(ThemeService);

    readonly profile = this.profileFacade.profile;

    readonly initials = computed(() => {
        const user = this.profile();
        if (!user) {
            return '';
        }
        return user.email.charAt(0).toUpperCase();
    });
}
